<template>
  <div class="vl-comp-dvp">
    <!--头部-->
    <header class="h-head">
      <el-button size="small" type="primary" @click="setBaseTmp">使用模板</el-button>
      <el-button size="small" type="primary" @click="projectSetting">设置</el-button>
      <el-button size="small" type="primary" :loading="saveLoading" @click="saveTemp">保存</el-button>
      <el-button size="small" type="primary" :loading="publishLoading" @click="projectPublish">发布</el-button>
    </header>

    <!--内容区-->
    <div class="h-main">
      <!--代码区域-->
      <div class="hm-code">
        <!--html区域-->
        <div class="hm-box-item hm-html vl-scroll-style">
          <span class="mb-sub-title">HTML</span>
          <textarea placeholder="输入 HTML 代码……" id="code-html" class="form-control" rows="11"></textarea>
        </div>
        <div class="hm-drag-left"
             id="dragLeft"
             @mousedown.stop="dragStartItem($event, 'hm-html', 'hm-css', 'dragLeft')"
        ></div>
        <!--css区域-->
        <div class="hm-box-item hm-css vl-scroll-style">
          <span class="mb-sub-title">CSS</span>
          <textarea placeholder="输入 CSS 代码……" id="code-css" class="form-control" rows="11"></textarea>
        </div>
        <div class="hm-drag-right"
             id="dragRight"
             @mousedown.stop="dragStartItem($event, 'hm-css', 'hm-js', 'dragRight')"
        ></div>
        <!--js区域-->
        <div class="hm-box-item hm-js vl-scroll-style">
          <span class="mb-sub-title">JAVASCRIPT</span>
          <textarea placeholder="输入 JavaScript 代码……" id="code-js" class="form-control" name="code" rows="10"></textarea>
        </div>
      </div>
      <!--上下拖拽条-->
      <div class="hm-drag-body" id="dragBody" @mousedown.stop="dragStartBody"></div>
      <!--效果展示区域-->
      <div class="hm-body vl-scroll-style">
        <div id="output" class="mb-iframe"></div>
      </div>
    </div>

    <!--用户输入配置信息弹窗-->
    <el-dialog
      title="配置信息"
      :visible.sync="configDialog"
      :close-on-click-modal="false"
      width="800px">
      <div class="vl-config-box">
        <!--弹窗左侧用户信息-->
        <div class="lc-item lc-left">
          <!--用户已登录-->
          <div class="lt-load" v-if="isLogin">
            <h2>
              <span>Hi! 你好, {{userInfo.userName}}</span>
              <el-button type="text" @click="loginOut">退出</el-button>
            </h2>
            <p class="lt-tip">说明：需提交平台用户测试账号，用于组件数据联调</p>
          </div>
          <!--用户未登录-->
          <div class="lt-login" v-else>
            <el-form :model="configForm" status-icon ref="configForm" label-width="60px">
              <el-form-item
                label="账号"
                prop="account"
                :rules="{
                required: true, message: '请输入账号', trigger: 'blur'
              }">
                <el-input v-model="configForm.account" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item
                label="密码"
                prop="password"
                :rules="{
                required: true, message: '请输入密码', trigger: 'blur'
              }">
                <el-input type="password" v-model="configForm.password" autocomplete="off"></el-input>
              </el-form-item>
              <p class="lt-tip">说明：需提交平台用户测试账号，用于组件数据联调</p>
              <el-form-item>
                <el-button type="primary" :loading="addUserLoading" @click="submitForm('configForm')">提交用户信息</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <!--弹窗右侧Url配置-->
        <div class="lc-item lc-right">
          <el-form :model="configForm" status-icon ref="reqForm" label-width="120px">
            <el-form-item label="Module Secret:">
              <p class="lr-secret">{{moduleSecret}}</p>
            </el-form-item>
            <el-form-item
              label="请求地址:"
              prop="reqUrl"
              :rules="{
                required: true, message: '请输入请求地址', trigger: 'blur'
              }">
              <el-input v-model="configForm.reqUrl" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="addUrlLoading" @click="submitReqUrl('reqForm')">提交接口地址</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import {
    PersonalPostUpdateModuleUserInfo,
    PersonalPostUpdateModuleApiInfo,
    PersonalPostUpdateModuleConfig,
    PersonalGetModuleConfigById,
    PersonalGetModuleManageLoginOut
  } from '@/views/index/api/personalCenter/api.personalCenter.js';
  import { ajaxCtx } from "@/config/config.js";
  export default {
    data() {
      return {
        refreshTime: 2000, // 页面刷新时间
        cmOpt: {
          mode: 'text/html', // text/html, css, javascript
          gutter: true,
          lineNumbers: true, // 显示行号
          autoCloseBrackets:true,
          lineWrapping: true, // 文字过长时，是换行（wrap）还是滚动(scroll)，默认滚动
          matchBrackets: true, // 匹配括号
          autoCloseTags: true, // tag展开收起
          autocorrect: true, // 自动更正
          theme: 'ayu-mirage'
        },
        htmlEditor: null, // cm的html编辑对象
        cssEditor: null, // css同上
        jsEditor: null, // js同上
        baseHtml: '', // 基础html
        baseCss: '', // 基础css
        baseJs: '', // 基础js
        configDialog: false, // 配置弹窗
        isLogin: false, // 判断是否已经登录
        userInfo: {
          userId: null,
          userName: ''
        }, // 登录之后获取到的用户信息
        configForm: {
          account: '',
          password: '',
          reqUrl: '', // 第三方自己的接口地址
        }, // 配置信息表单
        addUserLoading: false, // 提交用户信息Loading
        addUrlLoading: false, // 提交请求地址loading

        // 跟我们业务端交互字段
        moduleId: null,
        ifWindow: null, // iframe的window对象
        setConfigTimer: null,
        publishLoading: false,
        saveLoading: false,
        reqUrl: '',
        moduleSecret: '',
      }
    },
    mounted() {
      this.initCodeMirror();
      this.moduleId = this.$route.query.moduleId;
      this.reqUrl = ajaxCtx.base + 'company/moduleManage/getModuleInfo';
      this.initBaseTemp();
      this.getModuleConfigData();
    },
    methods: {
      /**
       * 获取组件配置信息
       * */
      getModuleConfigData() {
        PersonalGetModuleConfigById({moduleId: this.moduleId}).then(res => {
          if (res && res.result) {
            if (res.result.userId) {
              this.isLogin = true;
              this.userInfo.userId = res.result.userId;
              this.userInfo.userName = res.result.userName;
            }
            if (res.result.moduleApi) {
              this.configForm.reqUrl = res.result.moduleApi;
            }
            // 如果已经有html,css,js数据则直接取这里的
            if (res.result.moduleHtml || res.result.moduleCss || res.result.moduleJs) {
              this.htmlEditor.getDoc().setValue(res.result.moduleHtml);
              this.cssEditor.getDoc().setValue(res.result.moduleCss);
              this.jsEditor.getDoc().setValue(res.result.moduleJs);
            }
            this.moduleSecret = res.result.moduleSecret;
          }
        })
      },

      /**
       * 设置用户配置
       * */
      setUserConfig() {
        try {
          // 获取到了用户信息直接写入SSOPTemp
          this.ifWindow.SSOPTemp.setConfigUid(
            this.userInfo.userId,
            this.moduleId,
            this.reqUrl
          );
        } catch (err) {
          if (this.setConfigTimer) clearTimeout(this.setConfigTimer);
          this.setConfigTimer = setTimeout(() => {
            this.setUserConfig();
          }, 1000)
        }
      },
      /**
       * 初始化基础html内容
       * */
      initBaseTemp() {
        this.baseHtml = '' +
          '<!DOCTYPE html>\n' +
          '<html>\n' +
          '<head>\n\t' +
          '<meta charset="utf-8">\n\t' +
          '<title>文档标题</title>\n\t' +
//          '<script src="http://nx-storage-public.obs.cn-north-4.myhuaweicloud.com/app_portal/public/2021/0610/Wm/du/n0/axios.min.js">' + '</sc' + 'ript>\n\t' +
//          '<script src="http://nx-storage-public.obs.cn-north-4.myhuaweicloud.com/app_portal/public/2021/0610/Rc/od/IY/vue.js">' + '</sc' + 'ript>\n\t' +
//          '<script src="http://nx-storage-public.obs.cn-north-4.myhuaweicloud.com/app_portal/public/2021/0610/Mo/We/Oo/jquery.min.js">' + '</sc' + 'ript>\n\t' +
//          '<script src="http://nx-storage-public.obs.cn-north-4.myhuaweicloud.com/app_portal/public/2021/0610/oO/GF/X5/element-ui.js">' + '</sc' + 'ript>\n\t' +
//          '<script src="http://nx-storage-public.obs.cn-north-4.myhuaweicloud.com/app_portal/public/2021/0619/GD/QM/87/ssopTemp.js">' + '</sc' + 'ript>\n\t' +
//          '<link rel="stylesheet" href="http://nx-storage-public.obs.cn-north-4.myhuaweicloud.com/app_portal/public/2021/0610/AV/uL/LO/element-ui.css">\n' +
//          '<link rel="stylesheet" href="http://nx-storage-public.obs.cn-north-4.myhuaweicloud.com/app_portal/public/2021/0610/vX/LJ/lj/common.css">\n' +
          `<script src="${window.ENV_API.DOP_STATIC_URL}/2021/0619/Mq/pc/assets/js/axios.min.js">` + '</sc' + 'ript>\n\t' +
          `<script src="${window.ENV_API.DOP_STATIC_URL}/2021/0619/Mq/pc/assets/js/vue.js">` + '</sc' + 'ript>\n\t' +
          `<script src="${window.ENV_API.DOP_STATIC_URL}/2021/0619/Mq/pc/assets/js/jquery.min.js">` + '</sc' + 'ript>\n\t' +
          `<script src="${window.ENV_API.DOP_STATIC_URL}/2021/0619/Mq/pc/assets/js/element-ui.js">` + '</sc' + 'ript>\n\t' +
          `<script src="${window.ENV_API.DOP_STATIC_URL}/2021/0619/Mq/pc/assets/js/ssopTemp.js">` + '</sc' + 'ript>\n\t' +
          `<link rel="stylesheet" href="${window.ENV_API.DOP_STATIC_URL}/2021/0619/Mq/pc/assets/css/element-ui.css">\n` +
          `<link rel="stylesheet" href="${window.ENV_API.DOP_STATIC_URL}/2021/0619/Mq/pc/assets/css/common.css">\n` +
          '</head>\n' +
          '<body>\n\t' +
          '<div id="app">\n\t' +
          '   <div \n' +
          '        class="rl-item" \n' +
          '        v-for="(item, index) in resourceList" \n' +
          '        :key="\'rl-item\' + index">\n' +
          '     <div class="rt-img">\n' +
          '       <img :src="item.source_url" alt="">\n' +
          '     </div> \n' +
          '     <div class="rt-info">\n' +
          '       <h5>{{item.title}}</h5>\n' +
          '       <p>浏览：{{item.views_number}}</p>\n' +
          '     </div>\n' +
          '  </div>\n' +
          '</div>\n' +
          '</body>\n' +
          '</html>\n';

        this.baseJs = '' +
          'new Vue({\n' +
          '  el: \'#app\',\n' +
          '  data() {\n' +
          '    return {\n' +
          '      resourceList: [\n' +
          '    \n' +
          '      ], // 资源列表\n' +
          '    }\n' +
          '  },\n' +
          '  mounted() {\n' +
          'SSOPTemp.getComponentDetail().then(res => {\n' +
          '      this.resourceList = res;\n' +
          '    })\n' +
          '  },\n' +
          '  methods: {\n' +
          '\n' +
          '    \n' +
          '  }\n' +
          '})'

        this.baseCss = '' +
          '.rl-item {\n' +
          '  display: flex;\n' +
          '  width: 100%;\n' +
          '  height: 50px;\n' +
          '  margin-top: 20px;\n' +
          '}\n' +
          '.rl-item .rt-img {\n' +
          '  width: 50px;\n' +
          '  height: 50px;\n' +
          '  margin-right: 20px;\n' +
          '}\n' +
          '.rl-item .rt-img img {\n' +
          '  width: 100%;\n' +
          '  height: 100%;\n' +
          '}\n' +
          '.rl-item .rt-info {\n' +
          '  display: flex;\n' +
          '  flex-direction: column;\n' +
          '  justify-content: space-between;\n' +
          '}\n' +
          '.rl-item .rt-info h5 {\n' +
          '  font-size: 16px;\n' +
          '  color: #32326A;\n' +
          '}\n' +
          '.rl-item .rt-info p {\n' +
          '  font-size: 14px;\n' +
          '  color: #79799D;\n' +
          '}'
      },

      /**
       * 初始化codeMirror,生成htmlEditor,cssEditor,jsObj对象
       * */
      initCodeMirror() {
        // html editor
        let htmlEl = document.querySelector('#code-html');
        let htmlOpt = Object.assign({}, this.cmOpt);
        this.htmlEditor = window.CodeMirror.fromTextArea(htmlEl, htmlOpt);
        this.htmlEditor.on('change', this.submitTryit());

        // css editor
        let cssEl = document.querySelector('#code-css');
        let cssOpt = Object.assign({}, this.cmOpt, {mode: 'css'});
        this.cssEditor = window.CodeMirror.fromTextArea(cssEl, cssOpt);
        this.cssEditor.on('change', this.submitTryit());

        // css editor
        let jsEl = document.querySelector('#code-js');
        let jsOpt = Object.assign({}, this.cmOpt, {mode: 'javascript'});
        this.jsEditor = window.CodeMirror.fromTextArea(jsEl, jsOpt);
        this.jsEditor.on('change', this.submitTryit());
      },

      /**
       * 使用基础Html内容
       * */
      setBaseTmp() {
        this.htmlEditor.getDoc().setValue(this.baseHtml);
        this.cssEditor.getDoc().setValue(this.baseCss);
        this.jsEditor.getDoc().setValue(this.baseJs);
      },

      /**
       * 生成iframe，渲染具体内容
       * */
      submitTryit() {
        let timer = null;
        return () => {
          if (timer) {
            clearTimeout(timer)
          }
          timer = setTimeout(() => {
            // 基础模板
            let text = this.getCurrentHtml();
            let ifr = document.createElement("iframe");
            let ifrAttr = {
              sandbox: "allow-downloads allow-forms allow-modals allow-pointer-lock allow-popups allow-presentation allow-same-origin allow-scripts allow-top-navigation-by-user-activation",
              allow: "camera; geolocation; microphone",
              scrolling: "no",
              allowtransparency: "true",
              allowpaymentrequest: "true",
              allowfullscreen: "true",
              frameborder: "0",
              class: 'iframe-result',
            }
            for (let ifrKey in ifrAttr) {
              ifr.setAttribute(ifrKey, ifrAttr[ifrKey]);
            }
            document.getElementById("output").innerHTML = "";
            document.getElementById("output").appendChild(ifr);

            let ifrw = (ifr.contentWindow) ? ifr.contentWindow: (ifr.contentDocument.document) ? ifr.contentDocument.document: ifr.contentDocument;
            this.ifWindow = ifrw;
            ifrw.document.open();
            ifrw.document.write(text);
            ifrw.document.close();
            this.setUserConfig();
          }, this.refreshTime)
        }
      },

      /**
       * 组装当前的html,css,js
       * */
      getCurrentHtml() {
        let html = this.htmlEditor.getValue(),
          css = this.cssEditor.getValue(),
          js = this.jsEditor.getValue(),
          src = html;
        if (html) {
          var patternHtmlTag = /<html([^>]*)>/im;
          var array_matches_html_tag = patternHtmlTag.exec(src);
          if (array_matches_html_tag) {
            src = src.replace('<html>', '<html ' + array_matches_html_tag[1] + '>');
          }
          var patternHead = /<head[^>]*>((.|[\n\r])*)<\/head>/im
          var array_matches_head = patternHead.exec(src);

          var patternBodyTag = /<body([^>]*)>/im;
          var array_matches_body_tag = patternBodyTag.exec(src);
          if (array_matches_body_tag) {
            src = src.replace('<body>', '<body ' + array_matches_body_tag[1] + '>');
          }

        }

        if (css.indexOf('<style>') !== -1) {
          this.$MyMessage('CSS 编辑框不需要 <style> 标签');
          return false;
        } else if (js.indexOf('<script>') !== -1) {
          this.$MyMessage('avaScript 编辑框不需要 <script> 标签');
          return false;
        }

        // CSS
        if(css) {
          css = '<style>' + css + '</style>';
          if (array_matches_head) {
            src = src.replace('</head>', css + '</head>');
          } else if (array_matches_body_tag) {
            src = src.replace('</body>', css + '</body>');
          } else {
            src +=  css;
          }
        }

        // Javascript
        if(js) {
          js = '<script>' + js + '</sc' + 'ript>';
          if (array_matches_body_tag) {
            src = src.replace('</body>', js + '</body>');
          } else {
            src +=  js;
          }
        }
        return src;
      },

      /**
       * 发布当前页面
       * */
      projectPublish() {
        if (this.Trim(this.htmlEditor.getValue(), 'g')) {
          let text = this.getCurrentHtml();
          let params = {
            status: '2',
            moduleHtml: this.htmlEditor.getValue(),
            moduleJs: this.jsEditor.getValue(),
            moduleCss: this.cssEditor.getValue(),
            moduleId: this.moduleId,
            moduleStatement: text,
          }
          this.publishLoading = true;
          PersonalPostUpdateModuleConfig(params).then(res => {
            if (res) {
              this.$MyMessage('发布成功', 'success')
            }
            this.publishLoading = false;
          })
        } else {
          this.$MyMessage('html内容不能为空')
        }
      },

      /**
       * 保存当前页面
       * */
      saveTemp() {
        let params = {
          status: '1',
          moduleHtml: this.htmlEditor.getValue(),
          moduleJs: this.jsEditor.getValue(),
          moduleCss: this.cssEditor.getValue(),
          moduleId: this.moduleId
        }
        this.saveLoading = true;
        PersonalPostUpdateModuleConfig(params).then(res => {
          if (res) {
            this.$MyMessage('保存成功', 'success')
          }
          this.saveLoading = false;
        })
      },

      /**
       * 设置配置
       * */
      projectSetting() {
        this.configDialog = true;
      },

      /**
       * 提交账号密码
       * */
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.addUserLoading = true;
            let params = {
              moduleId: this.moduleId,
              loginName: this.configForm.account,
              password: this.configForm.password
            }
            PersonalPostUpdateModuleUserInfo(params).then(res => {
              if (res && res.result) {
                let {userId, userName} = res.result;
                this.userInfo.userId = userId;
                this.userInfo.userName = userName;
                this.isLogin = true;
                this.$refs[formName].resetFields();
              }
              this.addUserLoading = false;
            })
          }
        })
      },

      /**
       * 退出登录
       * */
      loginOut() {
        PersonalGetModuleManageLoginOut({moduleId: this.moduleId}).then(res => {
          if (res) {
            this.$MyMessage('退出成功', 'success');
            this.isLogin = false;
            this.userInfo = {
              userId: null,
              userName: ''
            }
          }
        })
      },

      /**
       * 提交或修改url
       * */
      submitReqUrl(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.addUrlLoading = true;
            let params = {
              moduleId: this.moduleId,
              moduleApi: this.configForm.reqUrl
            }
            PersonalPostUpdateModuleApiInfo(params).then(res => {
              if (res) {
                this.$MyMessage('提交成功', 'success');
              }
              this.addUrlLoading = false;
            })
          }
        })
      },

      /**
       * 左右条拖拽开始
       * */
      dragStartItem(ev, leftEl, rightEl, targetEl) {
        window.event.returnValue = false;
        let x = ev.clientX - $(`#${targetEl}`).offset().left;
        let leftWidth = $(`.${leftEl}`).width();
        let rightWidth = $(`.${rightEl}`).width();
        $('body').on('mousemove', event => {
          let distance = event.clientX - ev.clientX;
          if ((leftWidth + distance) > 200 && (rightWidth - distance) > 200) {
            $(`#${targetEl}`).css({
              left: event.clientX - x,
            })
            $(`.${leftEl}`).css({
              width: leftWidth + distance + 'px'
            })
            $(`.${rightEl}`).css({
              width: rightWidth - distance + 'px'
            })
          }
        })
        $('body').on('mouseup', () => {
          $('body').off('mousemove')
        })
      },


      /**
       * 上下条拖拽开始
       * */
      dragStartBody(ev) {
        window.event.returnValue = false;
        let y = ev.clientX - $('#dragBody').offset().top;
        let codeHeight = $('.hm-code').height();
        let bodyHeight = $('.hm-body').height();
        $('body').on('mousemove', event => {
          $('#dragBody').css({
            left: event.clientY - y,
          })
          let distance = event.clientY - ev.clientY;
          $('.hm-code').css({
            height: codeHeight + distance + 'px'
          })
          $('.hm-body').css({
            height: bodyHeight - distance + 'px'
          })
        })
        $('body').on('mouseup', () => {
          $('body').off('mousemove')
        })
      },
    },
    beforeDestroy() {

    }
  }
</script>
<style lang="scss" scoped>
  .vl-comp-dvp {
    width: 100%;
    height: 100%;
    background: #1f2430;
    .h-head {
      width: 100%;
      height: 70px;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      background: #2d2e33;
      .el-button {
        margin-right: 20px;
      }
    }
    .h-main {
      width: 100%;
      height: calc(100% - 70px);
      .hm-code {
        width: 100%;
        height: calc(50% - 5px);
        position: relative;
        white-space: nowrap;
        .hm-box-item {
          width: 33.3%;
          height: 100%;
          display: inline-block;
          position: relative;
          .mb-sub-title {
            position: absolute;
            right: 15px;
            top: 5px;
            display: block;
            padding: 5px;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            color: #23527c;
            background: rgba(243, 245, 246, .6);
            z-index: 29;
          }
        }
        .hm-css {}
        .hm-js {}
        .hm-drag-left {
          position: absolute;
          top: 0;
          left: 33%;
          width: 10px;
          height: 100%;
          background: #333642;
          cursor: w-resize;
          z-index: 30;
        }
        .hm-drag-right {
          position: absolute;
          top: 0;
          right: 33%;
          width: 10px;
          height: 100%;
          background: #333642;
          cursor: w-resize;
          z-index: 30;
        }
      }
      .hm-drag-body {
        width: 100%;
        height: 10px;
        background: #333642;
        cursor: n-resize;
      }
      /*展示内容*/
      .hm-body {
        width: 100%;
        height: calc(50% - 5px);
        min-height: 220px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #1f2430;
        .mb-iframe {
          width: 340px;
          height: 210px;
          background: #fff;
          border: 1px solid #666;
        }
      }
    }
    .vl-config-box {
      width: 100%;
      height: 400px;
      display: flex;
      .lc-item {
        width: 50%;
        padding: 20px;
        .lt-load {
          h2 {
            display: flex;
            justify-content: space-around;
            align-items: center;
          }
        }
      }
      .lc-left {
        border-right: 1px solid #666;
        .lt-tip {
          color: #999999;
        }
      }
      .lr-secret {
        color: #4286F5;
      }
    }
  }
</style>
<style lang="scss">
  .lc-item {
    .el-form {
      .el-form-item {
        margin-top: 40px;
      }
    }
  }
  .CodeMirror {
    border: 0px solid #808080;
    height: 100%;
    font-size: 14px;
    line-height: 18px;
    .CodeMirror-gutters {
      border-color: #808080;
    }
    .CodeMirror-vscrollbar {
      // 火狐#666B7A
      scrollbar-width: thin;
      scrollbar-color: #666B7A;
      scrollbar-track: #666B7A;
      -ms-scrollbar-track: #666B7A;
      // scrollbar-color: #ef5555 transparent;
      // scrollbar-track-color: #ef5555 transparent;
      // -ms-scrollbar-track-color: #ef5555 transparent;

      // ie
      scrollbar-arrow-color: #666B7A;
      scrollbar-base-color: #666B7A;
      scrollbar-track-color: #666B7A;
      scrollbar-shadow-color: #666B7A;

      &::-webkit-scrollbar {/*滚动条整体样式*/
        width: 10px;
        height: 10px;
      }
      &::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        background-color: #666B7A;
        @include setColor("background-color", "chunk_6");
        border-radius:6px;
      }
      &::-webkit-scrollbar-track {/*滚动条里面轨道*/
        border-radius: 2px;
      }
    }
  }
  .iframe-result {
    width: 100%;
    height: 100%;
  }
</style>
